import React from 'react'
import styled, { keyframes } from 'styled-components'
import { ReactComponent as LoaderSVG } from '../svg/loader.svg'
import { mobile } from '../styles/media'

const Loading: React.FC<{ maximize?: boolean; suspense?: boolean }> = ({ maximize = true, suspense }) => {
  return (
    <LoadingContainer maximize={maximize} suspense={suspense}>
      <Loader />
    </LoadingContainer>
  )
}

const LoadingContainer = styled.div<{ maximize: boolean; suspense?: boolean }>`
  display: flex;
  height: ${({ maximize }) => (maximize ? '100%' : 'unset')};
  flex: 1;
  width: 100%;
  justify-content: center;
  align-items: ${({ suspense }) => (suspense ? 'center' : 'start')};

  @media ${mobile} {
    align-items: center;
  }
`

const rotateRight = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`
const rotateLeft = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(-360deg);
  }
`

const Loader = styled(LoaderSVG)`
  width: 100%;
  height: 100%;
  padding: 25px;

  max-width: 300px;
  max-height: 300px;

  circle {
    transform-origin: 50% 50%;
    &:first-of-type {
      animation: ${rotateRight} 10s linear infinite;
    }
    &:last-of-type {
      animation: ${rotateLeft} 20s linear infinite;
    }
  }

  @media ${mobile} {
    max-width: 200px;
    max-height: 200px;
  }
`

export default Loading
